import React from 'react'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'
import { ZariContext } from '_zari/context'

import { Form, Button, Row, Col, Portlet } from '_zari/core'
import Yup from '_zari/validation/_yup'

import { DownloadAxiosFile } from "utils";

import * as FormGroups from './formGroups'

import * as ActivosFijosService from 'services/activosFijos.service'

export const ValidationSchema = Yup.object().shape({
  mes: Yup.string().length(2).required()
})

const ReporteCajaBancos = () => {
  const __adminContext = React.useContext(AdminContext)
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      mes: __adminContext.mesTrabajo || '',
    }
  }, [__adminContext])

  const onSubmit = React.useCallback(
    async formData => {
      __zariContext.loader.open('Descargando reporte de activos...')
      await ActivosFijosService.descargarReporteActivos(formData)
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    },
    [__zariContext]
  )
  return (
    <>
      <Row className='zari-slim-form'>
        <Col md={6}>
          <Portlet>
            <Portlet.Header title='Reporte De Activos' />
            <Portlet.Body>
              <Row>
                <Col md={12}>
                  {__adminContext.mesTrabajo && (
                    <Formik initialValues={formInitialValues} validationSchema7={ValidationSchema} onSubmit={onSubmit}>
                      {({ errors, touched, isSubmitting, handleSubmit, values, setValues, handleChange }) => (
                        <Form>
                          <Row>
                            <Col md={12}>
                              <FormGroups.MesContabilidadFormGroup
                                idFormato='reporteDiario'
                                iError={errors.mes}
                                values
                                iTouched={touched.mes}
                                fIsSubmitting={isSubmitting}
                              />
                              <Row>
                                <Col md={12} className='text-right'>
                                  <Button disabled={isSubmitting} onClick={handleSubmit}>
                                    {isSubmitting ? 'Descargando reporte' : 'Descargar'}
                                  </Button>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  )}
                </Col>
              </Row>
            </Portlet.Body>
          </Portlet>
        </Col>
      </Row>
    </>
  )
}

export default React.memo(ReporteCajaBancos)
